export default __webpack_public_path__ + "41afbde403cccb65388366ca61f07862.jpg";